import { Box, HStack } from '@chakra-ui/react'
import React from 'react'
import { AiFillShopping, AiOutlineMinus } from 'react-icons/ai'
import { FaShoppingCart } from 'react-icons/fa';
import Input from './Input'

export default function StoreList({ Payload, setPayload, oldItem = [], data, i, type }) {

    let itemToUpdate = oldItem;


    const handleStore = (e) => {
        //get the item index to update
        let objIndex = itemToUpdate.findIndex((obj) => obj.id == data.id);

        // console.log("idd", objIndex, itemToUpdate[objIndex]);

        itemToUpdate[objIndex].name = e.target.value

        setPayload({ ...Payload, name: itemToUpdate });
    }

    const removeItem = (id) => {
        let newItem = oldItem.filter((obj) => (
            obj.id !== data.id
        ))

        setPayload({ ...Payload, name: newItem })
    }
    return (
        <Box>
            {
                type == "store" ? (
                    <HStack>
                        <Input leftIcon={<AiFillShopping />} iconColor="black" labelBg='#fff' label='Store name' id="name" type='text' value={data.name} val={data.name != "" ? true : false} onChange={handleStore} />
                        <Box display={i == 0 ? "none" : "flex"} cursor="pointer">
                            <AiOutlineMinus onClick={() => removeItem(data.id)} />
                        </Box>
                    </HStack>
                ) : (
                    <HStack>
                        <Input leftIcon={<FaShoppingCart />} iconColor="black" labelBg='#fff' label='Category name' id="name" type='text' value={data.name} val={data.name != "" ? true : false} onChange={handleStore} />
                        <Box display={i == 0 ? "none" : "flex"} cursor="pointer">
                            <AiOutlineMinus onClick={() => removeItem(data.id)} />
                        </Box>
                    </HStack>
                )
            }

        </Box>


    )
}
